import { render, staticRenderFns } from "./WorkbenchWrap.vue?vue&type=template&id=1ced74a8&scoped=true"
import script from "./WorkbenchWrap.vue?vue&type=script&lang=js"
export * from "./WorkbenchWrap.vue?vue&type=script&lang=js"
import style0 from "./WorkbenchWrap.vue?vue&type=style&index=0&id=1ced74a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ced74a8",
  null
  
)

export default component.exports